
import { Message } from 'element-ui';
import { Toast } from 'vant';
import { formatApiE2e, formatApi } from '../baseApi';

/**
 * 获取工单数据
 */
export async function queryOriginTicket(params) {
  const result = await formatApiE2e({
    Action: 'PlayBack',
    Method: 'QueryOriginTicket',
    Data: {
      ProcessDefinitionKey: params,
    },
  });

  const { data } = result;
  if (data.status !== 0) {
    Message.error(`获取工单数据接口出错 (ticket_base)：${data.msg}`);
    throw new Error(data.msg);
  }

  return data;
}

export async function queryLogInfoAllTask(TaskDefKey, TicketId) {
  const result = await formatApiE2e({
    Action: 'PlayBack',
    Method: 'QueryLogInfoAllTask',
    Data: {
      TaskDefKey,
      TicketId,
    },
  });

  const { data } = result;
  if (data.status !== 0) {
    Message.error(`获取工单数据接口出错 (ticket_base)：${data.msg}`);
    throw new Error(data.msg);
  }

  return data;
}

export async function addNewTicket(params) {
  const result = await formatApiE2e({
    Action: 'PlayBack',
    Data: params,
    Method: 'Create',
    SystemId: '2',
  });

  const { data } = result;
  if (data.status !== 0) {
    Message.error(`新建工单接口出错 (TicketCreate)：${data.msg}`);
    throw new Error(data.msg);
  }

  return data;
}

export async function queryPlayBackTicket(InstanceId) {
  const result = await formatApiE2e({
    Action: 'PlayBack',
    Data: {
      InstanceId,
    },
    Method: 'QueryPlayBackTicketHistoryInfo',
    SystemId: '2',
  });

  const { data } = result;
  if (data.status !== 0) {
    Message.error(`查询工单接口出错 (QueryPlayBackTicketHistoryInfo)：${data.msg}`);
    throw new Error(data.msg);
  }

  return data;
}

export async function addEndLog(Columns) {
  const result = await formatApiE2e({
    Action: 'OperateData',
    Method: 'run',
    SystemId: '2',
    SchemaId: 'origin_manual_task_log',
    OpType: 'Add',
    Columns,
  });

  // const { data } = result;
  // if (data.status !== 0) {
  //   Message.error(`查询工单结单记录出错 (origin_manual_task_log)：${data.msg}`);
  //   throw new Error(data.msg);
  // }

  // return data;
}

export async function checkPlayBack(InstanceId) {
  const result = await formatApiE2e({
    Action: 'PlayBack',     // 原样填写
    Data: {
      InstanceId,
    },
    Method: 'CheckOriginTicketByInstanceId',     // 原样填写
    SystemId: '2',     // (*必填) (可取值区间为[>0]) (要求数据类型[int]) 调用方系统标识
  });

  const { data } = result;
  if (data.status !== 0) {
    // Message.error(`查询工单仿真记录出错 (CheckOriginTicketByInstanceId)：${data.msg}`);
    throw new Error(data.msg);
  }

  return data;
}

export async function addUserTaskLog(TaskDefKey) {
  const result = await formatApiE2e({
    Action: 'QueryData',
    Method: 'run',
    SystemId: '2',
    SchemaId: 'origin_manual_task_log',
    ReturnTotalRows: 0,
    Data: {
      ResultColumns: {
        IbrokerUrl: '',
        Id: '',
        InstanceId: '',
        MethodName: '',
        ProcessData: '',
        ProcessUser: '',
        ServiceName: '',
        TaskDefKey: '',
        TicketId: '',
      },
      SearchCondition: {
        TaskDefKey,
      },
      Sorts: [
      ],
      Limit: {
        Size: 20,
        Start: 0,
      },
    },
  });

  const { data } = result;
  if (data.status !== 0) {
    Message.error(`查询工单仿真记录出错 (origin_manual_task_log)：${data.msg}`);
    throw new Error(data.msg);
  }

  return data;
}

export async function queryLog(SearchCondition = {}, SchemaId) {
  const result = await formatApiE2e({
    Action: 'QueryData',
    Method: 'run',
    SystemId: '2',
    SchemaId,
    ReturnTotalRows: 0,
    Data: {
      ResultColumns: SchemaId !== 'playback_manual_task_log' ? {
        ReqData: '',
        Result: '',
      } : { ProcessData: '' },
      SearchCondition,
      Sorts: [
      ],
      Limit: {
        Size: 20,
        Start: 0,
      },
    },
  });

  const { data } = result;
  if (data.status !== 0) {
    Message.error(`查询工单仿真记录出错 (origin_manual_task_log)：${data.msg}`);
    throw new Error(data.msg);
  }

  return data;
}

export async function queryRelation(SearchCondition = {}) {
  const result = await formatApiE2e({
    Action: 'QueryData',
    Method: 'run',
    SystemId: '1',
    SchemaId: 'ticket_relation',
    ReturnTotalRows: 0,
    Data: {
      ResultColumns: {
        InstanceId: '',
        OriginInstanceId: '',
        OriginTicketId: '',
        ProcessDefinitionKey: '',
        TicketId: '',
      },
      SearchCondition,
      Sorts: [
      ],
      Limit: {
        Size: 20,
        Start: 0,
      },
    },
  });

  const { data } = result;
  if (data.status !== 0) {
    Message.error(`查询工单仿真记录出错 (origin_manual_task_log)：${data.msg}`);
    throw new Error(data.msg);
  }

  return data;
}

export async function queryException(InstanceId) {
  const result = await formatApiE2e({
    Action: 'QueryData',
    Method: 'run',
    SystemId: '1',
    SchemaId: 'playback_exception_log',
    ReturnTotalRows: 0,
    Data: {
      ResultColumns: {
        ErrInfo: '',
        Id: '',
        InstanceId: '',
        NodeTitle: '',
        NodeType: '',
        TaskDefKey: '',
        TaskId: '',
      },
      SearchCondition: {
        InstanceId,
      },
      Sorts: [
      ],
      Limit: {
        Size: 20,
        Start: 0,
      },
    },
  });

  const { data } = result;
  if (data.status !== 0) {
    Message.error(`查询工单仿真记录出错 (playback_exception_log)：${data.msg}`);
    throw new Error(data.msg);
  }

  return data;
}

export async function queryVariable(SearchCondition) {
  const result = await formatApiE2e({
    Action: 'QueryData',
    Method: 'run',
    SystemId: '1',
    SchemaId: 'variables_quick_shot',
    ReturnTotalRows: 0,
    Data: {
      ResultColumns: {
        Id: '',
        InstanceId: '',
        InstanceType: '',
        LogTime: '',
        LogTitle: '',
        TaskDefKey: '',
        Variables: '',
      },
      SearchCondition,
      Sorts: [
      ],
      Limit: {
        Size: 1000,
        Start: 0,
      },
    },
  });

  const { data } = result;
  if (data.status !== 0) {
    Message.error(`查询工单仿真变量出错 (variables_quick_shot)：${data.msg}`);
    throw new Error(data.msg);
  }

  return data;
}